import {Nullable} from '../../../app/TypeHelpers'
import {BaseHttpError} from './BaseHttpError'
import {ErrorResponseBody} from '../../response/ErrorResponseBody'
import {HttpStatusCode} from '../../Constants'

export class HttpFatal extends BaseHttpError {

    constructor(status: HttpStatusCode, readonly responseBody: Nullable<ErrorResponseBody>) {
        super('HttpFatal', status, responseBody)
    }
}
